<template>
  <main class="page news-page">
    <div class="news-page__container">
      <ul class="breadcrumbs">
        <li class="breadcrumbs__item">
          <router-link :to="{ name: 'home'}">Главная</router-link>
        </li>
        <li class="breadcrumbs__item">
          <span>Новости</span>
        </li>
      </ul>
      <h1 class="news-page__title">Новости</h1>
      <ul class="news-page__items" v-if="$store.state.news && $store.state.news.data.length">
        <li class="news-page__item" v-for="(news, index) in $store.state.news.data" :key="index">
          <router-link class="news" :to="{ name: 'article', params: { id: news.id } }" :title="news.title"
                       :aria-label="news.title">
            <img class="news__image" :src="news.img350 | findSource($store.state.api)" :alt="news.title"/>
            <h3 class="news__title">{{ news.title | optimalTitle }}</h3>
            <p class="news__subtitle">{{ news.subtitle | optimalTitle }}</p>
            <time class="news__date" :datetime="news.date_publication | robotDate">{{
                news.date_publication | humanDate
              }}
            </time>
          </router-link>
        </li>
      </ul>
      <span class="document-page__empty" v-else>Материалы отсутствуют</span>
      <div class="news-page__more"
           v-if="$store.state.news && $store.state.news.next_page_url && $store.state.news.data.length">
        <button class="button" @click="$store.dispatch('NEWS_PAGE', true)" type="button">Показать еще</button>
      </div>
    </div>
  </main>
</template>

<script>
export default {
  async asyncData ({ store }) {
    await store.dispatch('NEWS_PAGE')
  },
  name: 'NewsPage',
  // computed: {
  //   news () {
  //     if (this.$store.state.news) {
  //
  //     }
  //     return false
  //   }
  // },
  metaInfo () {
    return this.$store.state.department ? this.$seo(
      'common',
      'Новости',
      'управление образования, образование',
      'Сайт ' + this.$store.state.department.title + '. В сайте есть информация о проектах, учреждениях, актуальные новости и обращение к руководителю',
      'Новости',
      this.$store.state.api + this.$store.state.department.img_head,
      'Сайт ' + this.$store.state.department.title + '. В сайте есть информация о проектах, учреждениях, актуальные новости и обращение к руководителю'
    ) : this.$seo('common', '', '', '', '', '', '')
  }
}
</script>
